export const CLEAR_STATE = "CLEAR_STATE";

export const GET_ORGS_OF_ADMIN = "GET_ORGS_OF_ADMIN";
export const GET_ORGS_OF_ADMIN_SUCCESS = "GET_ORGS_OF_ADMIN_SUCCESS";
export const GET_ORGS_OF_ADMIN_FAIL = "GET_ORGS_OF_ADMIN_FAIL";

export const SET_ADMIN = "SET_ADMIN";
export const SET_ADMIN_SUCCESS = "SET_ADMIN_SUCCESS";
export const SET_ADMIN_FAIL = "SET_ADMIN_FAIL";

export const CHANGE_SHOW_DIALOGS = "CHANGE_SHOW_DIALOGS";

export const SET_SEARCHED_ORGS = "SET_SEARCHED_ORGS";

export const GET_ORGANIZATION = "GET_ORGANIZATION";
export const GET_ORGANIZATION_SUCCESS = "GET_ORGANIZATION_SUCCESS";
export const GET_ORGANIZATION_FAIL = "GET_ORGANIZATION_FAIL";

export const GET_ALL_TENANTS = "GET_ALL_TENANTS";
export const GET_ALL_TENANTS_SUCCESS = "GET_ALL_TENANTS_SUCCESS";
export const GET_ALL_TENANTS_FAIL = "GET_ALL_TENANTS_FAIL";

export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const ADD_ORGANIZATION_SUCCESS = "ADD_ORGANIZATION_SUCCESS";
export const ADD_ORGANIZATION_FAIL = "ADD_ORGANIZATION_FAIL";

export const ADD_TENANT = "ADD_TENANT";
export const ADD_TENANT_SUCCESS = "ADD_TENANT_SUCCESS";
export const ADD_TENANT_FAIL = "ADD_TENANT_FAIL";

export const EDIT_TENANT = "EDIT_TENANT";
export const EDIT_TENANT_SUCCESS = "EDIT_TENANT_SUCCESS";
export const EDIT_TENANT_FAIL = "EDIT_TENANT_FAIL";

export const EDIT_ORGANIZATION = "EDIT_ORGANIZATION";
export const EDIT_ORGANIZATION_SUCCESS = "EDIT_ORGANIZATION_SUCCESS";
export const EDIT_ORGANIZATION_FAIL = "EDIT_ORGANIZATION_FAIL";

export const CHANGE_TENANT_ACTIVATION = "CHANGE_TENANT_ACTIVATION";
export const CHANGE_TENANT_ACTIVATION_SUCCESS =
  "CHANGE_TENANT_ACTIVATION_SUCCESS";
export const CHANGE_TENANT_ACTIVATION_FAIL = "CHANGE_TENANT_ACTIVATION_FAIL";

export const GET_TENANT_BY_ID = "GET_TENANT_BY_ID";
export const GET_TENANT_BY_ID_SUCCESS = "GET_TENANT_BY_ID_SUCCESS";
export const GET_TENANT_BY_ID_FAIL = "GET_TENANT_BY_ID_FAIL";

export const DELETE_TENANT = "DELETE_TENANT";
export const DELETE_TENANT_SUCCESS = "DELETE_TENANT_SUCCESS";
export const DELETE_TENANT_FAIL = "DELETE_TENANT_FAIL";

export const GET_ORGANIZATION_BY_ID = "GET_ORGANIZATION_BY_ID";
export const GET_ORGANIZATION_BY_ID_SUCCESS = "GET_ORGANIZATION_BY_ID_SUCCESS";
export const GET_ORGANIZATION_BY_ID_FAIL = "GET_ORGANIZATION_BY_ID_FAIL";

export const GET_ORGANIZATION_USER = "GET_ORGANIZATION_USER";
export const GET_ORGANIZATION_USER_SUCCESS = "GET_ORGANIZATION_USER_SUCCESS";
export const GET_ORGANIZATION_USER_FAIL = "GET_ORGANIZATION_USER_FAIL";

export const GET_TENANT_USER = "GET_TENANT_USER";
export const GET_TENANT_USER_SUCCESS = "GET_TENANT_USER_SUCCESS";
export const GET_TENANT_USER_FAIL = "GET_TENANT_USER_FAIL";

export const CHANGE_ORGANIZATION_ACTIVATION = "CHANGE_ORGANIZATION_ACTIVATION";
export const CHANGE_ORGANIZATION_ACTIVATION_SUCCESS =
  "CHANGE_ORGANIZATION_ACTIVATION_SUCCESS";
export const CHANGE_ORGANIZATION_ACTIVATION_FAIL =
  "CHANGE_ORGANIZATION_ACTIVATION_FAIL";

export const UPDATE_ORGANIZATION_USER = "UPDATE_ORGANIZATION_USER";
export const UPDATE_ORGANIZATION_USER_SUCCESS =
  "UPDATE_ORGANIZATION_USER_SUCCESS";
export const UPDATE_ORGANIZATION_USER_FAIL = "UPDATE_ORGANIZATION_USER_FAIL";

export const UPDATE_TENANT_USER = "UPDATE_TENANT_USER";
export const UPDATE_TENANT_USER_SUCCESS = "UPDATE_TENANT_USER_SUCCESS";
export const UPDATE_TENANT_USER_FAIL = "UPDATE_TENANT_USER_FAIL";

export const CHANGE_ORG_PASSWORD = "CHANGE_ORG_PASSWORD";
export const CHANGE_ORG_PASSWORD_SUCCESS = "CHANGE_ORG_PASSWORD_SUCCESS";
export const CHANGE_ORG_PASSWORD_FAIL = "CHANGE_ORG_PASSWORD_FAIL";

export const CHANGE_TENANT_PASSWORD = "CHANGE_TENANT_PASSWORD";
export const CHANGE_TENANT_PASSWORD_SUCCESS = "CHANGE_TENANT_PASSWORD_SUCCESS";
export const CHANGE_TENANT_PASSWORD_FAIL = "CHANGE_TENANT_PASSWORD_FAIL";

export const GET_USER_TOKEN = "GET_USER_TOKEN";
export const GET_USER_TOKEN_SUCCESS = "GET_USER_TOKEN_SUCCESS";
export const GET_USER_TOKEN_FAIL = "GET_USER_TOKEN_FAIL";

export const GET_USER_TOKEN_BY_TENANT_ID = "GET_USER_TOKEN_BY_TENANT_ID";

export const GET_ORGANIZATION_USAGE = "GET_ORGANIZATION_USAGE";
export const GET_ORGANIZATION_USAGE_SUCCESS = "GET_ORGANIZATION_USAGE_SUCCESS";
export const GET_ORGANIZATION_USAGE_FAIL = "GET_ORGANIZATION_USAGE_FAIL";

export const GET_ORGANIZATIONS_USAGE = "GET_ORGANIZATIONS_USAGE";
export const GET_ORGANIZATIONS_USAGE_SUCCESS =
  "GET_ORGANIZATIONS_USAGE_SUCCESS";
export const GET_ORGANIZATIONS_USAGE_FAIL = "GET_ORGANIZATIONS_USAGE_FAIL";

export const DOWNLOAD_USAGE = "DOWNLOAD_USAGE";
export const DOWNLOAD_USAGE_SUCCESS = "DOWNLOAD_USAGE_SUCCESS";
export const DOWNLOAD_USAGE_FAIL = "DOWNLOAD_USAGE_FAIL";

export const GET_ORG_POC = "GET_ORG_POC";
export const GET_ORG_POC_SUCCESS = "GET_ORG_POC_SUCCESS";
export const GET_ORG_POC_FAIL = "GET_ORG_POC_FAIL";

export const UPDATE_ORG_POC = "UPDATE_ORG_POC";
export const UPDATE_ORG_POC_SUCCESS = "UPDATE_ORG_POC_SUCCESS";
export const UPDATE_ORG_POC_FAIL = "UPDATE_ORG_POC_FAIL";

export const ADD_ORG_POC = "ADD_ORG_POC";
export const ADD_ORG_POC_SUCCESS = "ADD_ORG_POC_SUCCESS";
export const ADD_ORG_POC_FAIL = "ADD_ORG_POC_FAIL";

export const REMOVE_ORG_POC = "REMOVE_ORG_POC";
export const REMOVE_ORG_POC_SUCCESS = "REMOVE_ORG_POC_SUCCESS";
export const REMOVE_ORG_POC_FAIL = "REMOVE_ORG_POC_FAIL";

export const GET_ORG_ADMINS = "GET_ORG_ADMINS";
export const GET_ORG_ADMINS_SUCCESS = "GET_ORG_ADMINS_SUCCESS";
export const GET_ORG_ADMINS_FAIL = "GET_ORG_ADMINS_FAIL";

export const ADD_ORG_ADMIN = "ADD_ORG_ADMIN";
export const ADD_ORG_ADMIN_SUCCESS = "ADD_ORG_ADMIN_SUCCESS";
export const ADD_ORG_ADMIN_FAIL = "ADD_ORG_ADMIN_FAIL";
